import { apiSlice } from "./apiSlice";
import { ORDERS_URL } from "../constants";

export const ordersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createOrder: builder.mutation({
            query: (order) => ({
                url: ORDERS_URL,
                method: "POST",
                body: {...order}
            }),
        }),
        cancelOrder: builder.mutation({
            query: (id) => ({
                url: `${ORDERS_URL}/${id}`,
                method: 'PUT',
            }),
        }),
        getOrderDetails: builder.query({
            query: (id) => ({
                url: `${ORDERS_URL}/${id}`, // /api/orders/:id - SC
                method: "GET", //Get is default is there for info - SC
            }),
            keepUnusedDataFor: 5, // keep the data for 5 seconds - SC
        }),
        getMyOrders: builder.query({
            query: () => ({
                url: `${ORDERS_URL}/mine`,
            }),
            keepUnusedDataFor: 5, // keep the data for 5 seconds - SC
        }),
        getOrders: builder.query({
            query: () => ({
                url: ORDERS_URL,
            }),
            keepUnusedDataFor: 5, // keep the data for 5 seconds - SC
        }),
        deliverOrder: builder.mutation({
            query: (orderId) => ({
                url: `${ORDERS_URL}/${orderId}/deliver`,
                method: 'PUT',
            }),
        }),
        getOrdersByUser: builder.query({
            query: (userId) => ({
                url: `${ORDERS_URL}/user/${userId}`,
            }),
            keepUnusedDataFor: 5,
        }),
        capturePreOrder: builder.mutation({
            query: (orderId) => ({
                url: `${ORDERS_URL}/${orderId}/capture`,
                method: 'PUT',
            }),
        }),
        resendOrderEmail: builder.mutation({
            query: (orderId) => ({
                url: `${ORDERS_URL}/${orderId}/resend-email`,
                method: 'POST',
            }),
        }),
    }),
});

export const {
    useCreateOrderMutation,
    useGetOrderDetailsQuery,
    useGetMyOrdersQuery,
    useGetOrdersQuery,
    useDeliverOrderMutation,
    useGetOrdersByUserQuery,
    useCancelOrderMutation,
    useCapturePreOrderMutation,
    useResendOrderEmailMutation
} =
    ordersApiSlice;